import React, { useState } from 'react';
import Modal from 'react-modal';
import { TrashIcon } from '@heroicons/react/24/solid';
import Button from './Button';
import { axiosKK } from '../services/networkRequest';

const customStyles = {
  content: {
    display: 'flex',
  },
};

interface DeleteConfirmationModalProps {
  show: boolean;
  close: () => void;
  success: () => void;
  failure: () => void;
  id: number | string;
  directory: string;
  warningMessage: string;
}

export default function DeleteConfirmationModal({
  show,
  close,
  id,
  directory,
  warningMessage,
  success,
  failure,
}: DeleteConfirmationModalProps): JSX.Element {
  const [busy, setBusy] = useState(false);

  const onDelete = () => {
    if (busy) return;
    setBusy(true);
    axiosKK
      .delete(`${directory + id}`)
      .then(() => {
        success();
      })
      .catch(() => {
        failure();
      })
      .finally(() => setBusy(false));
  };

  return (
    <Modal
      isOpen={show}
      onRequestClose={close}
      style={customStyles}
      contentLabel="Confirmation Modal"
    >
      <section className="confirmation-modal">
        <div className="title">
          <h3>Are you sure?</h3>
        </div>
        <div className="content">
          <p>{warningMessage}</p>
        </div>
        <div className="buttons">
          <Button
            variant="danger"
            onClick={onDelete}
            loading={busy}
            leftIcon={<TrashIcon aria-hidden="true" />}
          >
            Confirm
          </Button>
          <Button variant="secondary" onClick={close} disabled={busy}>
            Cancel
          </Button>
        </div>
      </section>
    </Modal>
  );
}
